import { useForm } from 'react-hook-form'
import * as z from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { Button } from '@/common/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'

const formSchema = z.object({
	depositPoint: z.number().min(0, 'คะแนนต้องมากกว่าหรือเท่ากับ 0'),
	turnoverPoint: z.number().min(0, 'คะแนนต้องมากกว่าหรือเท่ากับ 0'),
	winPoint: z.number().min(0, 'คะแนนต้องมากกว่าหรือเท่ากับ 0'),
	losePoint: z.number().min(0, 'คะแนนต้องมากกว่าหรือเท่ากับ 0'),
	withdrawPoint: z.number().min(0, 'คะแนนต้องมากกว่าหรือเท่ากับ 0'),
	promotionTurnoverPoint: z.number().min(0, 'คะแนนต้องมากกว่าหรือเท่ากับ 0'),
})

export type RankExperienceSettingFormValues = z.infer<typeof formSchema>

interface RankExperienceSettingFormProps {
	defaultValues?: RankExperienceSettingFormValues
	onSubmit: (data: RankExperienceSettingFormValues) => void
	isSubmitting?: boolean
}

export default function RankExperienceSettingForm({
	defaultValues = {
		depositPoint: 0,
		turnoverPoint: 0,
		winPoint: 0,
		losePoint: 0,
		withdrawPoint: 0,
		promotionTurnoverPoint: 0,
	},
	onSubmit,
	isSubmitting = false,
}: RankExperienceSettingFormProps) {
	const form = useForm<RankExperienceSettingFormValues>({
		resolver: zodResolver(formSchema),
		defaultValues,
	})

	return (
		<Card>
			<CardHeader>
				<CardTitle>ตั้งค่าคะแนนประสบการณ์</CardTitle>
			</CardHeader>
			<CardContent>
				<Form {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
						<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
							{/* <FormField
								control={form.control}
								name="depositPoint"
								render={({ field }) => (
									<FormItem>
										<FormLabel required>EXP การฝากต่อ 1 บาท</FormLabel>
										<FormControl>
											<Input
												type="number"
												placeholder="กรอกคะแนน"
												onNumberChange={(value) => field.onChange(value ?? 0)}
												value={field.value}
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/> */}

							<FormField
								control={form.control}
								name="turnoverPoint"
								render={({ field }) => (
									<FormItem>
										<FormLabel required>EXP ยอดเทิร์นต่อ 1 เครดิต</FormLabel>
										<FormControl>
											<Input
												type="number"
												placeholder="กรอกคะแนน"
												onNumberChange={(value) => field.onChange(value ?? 0)}
												value={field.value}
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>

							{/* <FormField
								control={form.control}
								name="withdrawPoint"
								render={({ field }) => (
									<FormItem>
										<FormLabel required>EXP การถอนต่อ 1 บาท</FormLabel>
										<FormControl>
											<Input
												type="number"
												placeholder="กรอกคะแนน"
												onNumberChange={(value) => field.onChange(value ?? 0)}
												value={field.value}
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/> */}

							<FormField
								control={form.control}
								name="promotionTurnoverPoint"
								render={({ field }) => (
									<FormItem>
										<FormLabel required>
											EXP ยอดเทิร์นโปรโมชั่นต่อ 1 เครดิต
										</FormLabel>
										<FormControl>
											<Input
												type="number"
												placeholder="กรอกคะแนน"
												onNumberChange={(value) => field.onChange(value ?? 0)}
												value={field.value}
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
						</div>

						<div className="flex justify-end">
							<Button type="submit" disabled={isSubmitting}>
								{isSubmitting ? 'กำลังบันทึก...' : 'บันทึกการตั้งค่า'}
							</Button>
						</div>
					</form>
				</Form>
			</CardContent>
		</Card>
	)
}
